// extracted by mini-css-extract-plugin
export default {"phoneNumber":"dgb5r7F9ElIBcKtOVi5O"};